// extracted by mini-css-extract-plugin
export default {"image":"LX-z","loaded":"MX-z"};